/**
 * @packageDocumentation
 * @module f1/abstract-data-type
 */

import { t_rec_arr, t_rec, t_arr } from '../types';
import filter, { t_filter_fn } from './filter';

type t_remove_fn<V> = t_filter_fn<V>;

export interface Remove {
  /**
   * @public
   * @function f1.remove
   * @param fn the boolean function to decide if each value is excluded
   * @param adt the array or record we will filter
   * @example
   *
   * ```ts
   * f1.remove(v => v > 16, [16, 17, 18]) => [16]
   * ```
   *
   */
  <V>(fn: t_remove_fn<V>, adt: t_arr<V>): t_arr<V>;
  <V>(fn: t_remove_fn<V>, adt: t_rec<string, V>): t_rec<string, V>;
  <V>(fn: t_remove_fn<V>, adt: t_rec_arr<V>): t_rec_arr<V>;

  <V>(fn: t_remove_fn<V>): (adt: t_arr<V>) => t_arr<V>;
  <V>(fn: t_remove_fn<V>): (adt: t_rec<string, V>) => t_rec<string, V>;
  <V>(fn: t_remove_fn<V>): (adt: t_rec_arr<V>) => t_rec_arr<V>;
}

/**
 * @see Remove
 */
export default <V>(fn: t_remove_fn<V>, adt: t_rec_arr<V>): t_rec_arr<V> => {
  return filter((v, k, adt, stop) => !fn(v, k, adt, stop), adt);
};
